import React from 'react';
import { useParams } from 'react-router-dom';

import { ArchivalUnitCopy, EadNode } from 'types';

import { GridParams } from 'components/grid/grid-types';

import { ArchivalUnitFields } from './archival-unit-fields';
import { EadFields } from './ead-fields';

export function ArchivalAidChildrenDetail({
  item,
  ...rest
}: {
  item?: ArchivalUnitCopy | EadNode;
}) {
  const { ead } = useParams<GridParams>();
  return ead ? (
    <EadFields item={item as EadNode} {...rest} />
  ) : (
    <ArchivalUnitFields item={item as ArchivalUnitCopy} />
  );
}
